import CheckBoxActive from '../../icons/CheckBoxActive';
import CheckBoxInactive from '../../icons/CheckBoxInactive';
import COLOR from '../../constant/colorset';

interface Props {
  disabled?: boolean;
  checked: boolean;
  iconColor?: string;
}

export default function CheckIcon({ disabled = false, checked = false, iconColor = COLOR.kurlyPurple }: Props) {
  return (
    <>
      {checked ? (
        <CheckBoxActive width={24} height={24} fill={iconColor} />
      ) : (
        <CheckBoxInactive width={24} height={24} fill={disabled ? COLOR.btnGray : COLOR.kurlyWhite} />
      )}
    </>
  );
}
